import React, { useEffect, useRef } from 'react';

const VideoPage = () => {
    const videoRef = useRef(null);
    const videoUrl = "https://hik.elmecelettronica.com/sms/HCPEurl/commonvideobiz_KXT3ZYn0Xxa6mNUubwMj2CngbaOmP3Lbb346yzUQkSedPZfh2S4gueV0ju4neXBvk5MSDzXt0Ycshl%2BnagCQd5vmTrEV7SEzrG%2FNtKF%2FtmC3so%2F%2BWGsbqvtfYKuPZoLdzOrCg2tceYUW0Ut1Vq09SXSSVFtarjHrqBAlZI%2FUmaRtGVBwYpuzCVs6eV3ys7lsZeo3L%2Bg4Flkdw0PtmpCkdf5PyGhXnFWfEidJUIUfC0U1lA6k21M8wO5mCduwPmoV/live.m3u8";

    useEffect(() => {
        const video = videoRef.current;

        // Check if HLS.js is supported
        if (window.Hls && Hls.isSupported()) {
            const hls = new Hls({
                lowLatencyMode: true,
                liveSyncDurationCount: 3,
            });
            hls.loadSource(videoUrl);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                video.play();
            });

            // Clean up the Hls.js instance on component unmount
            return () => {
                if (hls) {
                    hls.destroy();
                }
            };
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
            // Fallback for Safari browsers that support HLS natively
            video.src = videoUrl;
            video.play();
        } else {
            alert("HLS not supported in this browser");
        }
    }, [videoUrl]);

    return (
        <div className="video-page-container">
            <header className="video-header">
                <h1 className="video-title">Live Camera Stream</h1>
            </header>
            <div className="video-player-container">
                <video
                    ref={videoRef}
                    id="video"
                    controls
                    autoPlay
                    muted
                    playsInline
                    className="video-player"
                >
                    Your browser does not support the video tag.
                </video>
            </div>
            <footer className="footer">
                <p className="footer-text">© 2026 Your Company. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default VideoPage;
